module.exports = function isBoolean(x) {
  return x === true || x === false;
};